var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#B8E8EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3495_21606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 25C44.0389 25 43.6667 25.3722 43.6667 25.8333V41.6667C43.6667 42.5833 42.9167 43.3333 42 43.3333C41.0833 43.3333 40.3333 42.5833 40.3333 41.6667V22.5C40.3333 21.1222 39.2111 20 37.8333 20H21.1667C19.7889 20 18.6667 21.1222 18.6667 22.5V41.6667C18.6667 43.5056 20.1611 45 22 45H42C43.8389 45 45.3333 43.5056 45.3333 41.6667V25.8333C45.3333 25.3722 44.9611 25 44.5 25ZM22 43.3333C21.0833 43.3333 20.3333 42.5833 20.3333 41.6667V22.5C20.3333 22.0389 20.7055 21.6667 21.1667 21.6667H37.8333C38.2944 21.6667 38.6667 22.0389 38.6667 22.5V41.6667C38.6667 42.2722 38.8278 42.8444 39.1167 43.3333H22Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 35H23.6666C23.2055 35 22.8333 35.3722 22.8333 35.8333C22.8333 36.2944 23.2055 36.6667 23.6666 36.6667H35.3333C35.7944 36.6667 36.1666 36.2944 36.1666 35.8333C36.1666 35.3722 35.7944 35 35.3333 35Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 38.3333H23.6666C23.2055 38.3333 22.8333 38.7055 22.8333 39.1666C22.8333 39.6277 23.2055 39.9999 23.6666 39.9999H30.3333C30.7944 39.9999 31.1666 39.6277 31.1666 39.1666C31.1666 38.7055 30.7944 38.3333 30.3333 38.3333Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 24.1667H24.5C23.5833 24.1667 22.8333 24.9167 22.8333 25.8334V30.8334C22.8333 31.7501 23.5833 32.5001 24.5 32.5001H34.5C35.4166 32.5001 36.1666 31.7501 36.1666 30.8334V25.8334C36.1666 24.9167 35.4166 24.1667 34.5 24.1667ZM34.5 30.8334H24.5V25.8334H34.5V30.8334Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3495_21606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 25,
    fill: "white",
    transform: "translate(18.6667 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.9e55943aac2bf7794f7a7311cf294ebe.svg";
export { ForwardRef as ReactComponent };